import { DictionaryEntity, PcsEntity } from '@app/pcs/models';
import { CalendarWatermark, calendarWatermarkDetailedFragment } from '@app/pcs/models/calendar';
import { EntityType, PropertyNameMapper } from '@app/shared/forms/property-mapper';
import { Dossier } from '@dossier/models/dossier';
import { trainId, trainIdMapper } from '@dossier/models/train-id';
import { gql } from 'apollo-angular';

// Navigation paths
export const BASE_COMPOSITE_RELATIONS_PATH = 'composite-relations';
export const ADD_COMPOSITE_RELATION_PATH = 'add-new-composite-relation';
export const EDIT_COMPOSITE_RELATION_PATH = 'edit-composite-relation';

export interface TimetableShiftingData {
  type: DictionaryEntity;
  days: number;
  hours: number;
  minutes: number;
}

export interface CompositeRelationDossier {
  id: number;
  dossier: Dossier;
  timetableShiftingData: TimetableShiftingData;
  runningDays?: CalendarWatermark;
  trainNumber?: string;
  pathNumber?: string;
}

export interface CompositeRelation {
  id: number;
  type: DictionaryEntity;
  name: string;
  comment: string;
  compositeDossiers: CompositeRelationDossier[];
}

export enum CompositeRelationAclActionMap {
  AddCompositeRelation = 'AddCompositeRelation',
  EditCompositeRelation = 'EditCompositeRelation'
}

export const compositeRelationMapper = new PropertyNameMapper({
  type: 'type',
  name: 'name',
  comment: 'comment',
  timetableShiftingData: 'shiftingInput',
  compositeDossiers: new PropertyNameMapper({
    trainNumber: 'trainNumber',
    dossier: new PropertyNameMapper({
      trainId: trainIdMapper
    }, {entityType: EntityType.Object})
  }, {entityName: PcsEntity.CompositeRelationDossier, entityType: EntityType.Array})
}, {entityName: PcsEntity.CompositeRelation});

export const compositeRelationDossier = gql`
  fragment compositeRelationDossier on CompositeRelationDossier {
    id
    compositeRelationId
    originDossier
    dossier {
      id
      title
      internationalTrainNr
      trainId {
        ...trainId
      }
    }
    timetableShiftingData {
      type {
        id
        description
      }
      days
      hours
      minutes
    }
    runningDays {
      ...calendarWatermarkDetailed
    }
    trainNumber
    pathNumber
  }
  ${trainId}
  ${calendarWatermarkDetailedFragment}
`;

export const compositeRelation = gql`
  fragment compositeRelation on CompositeRelation {
    id
    type {
      id
      description
    }
    name
    comment
    compositeDossiers {
      ...compositeRelationDossier
    }
  }
  ${compositeRelationDossier}
`;
